import { Schema } from '../create/components/license-form.schema';
import { LicenseYearForm } from './components/license-year-form';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { LicenseForm } from '../create/components/license-form';
import { withAuthentication } from '~/hocs/withAuthentication';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { useCreateLicenseMutation } from '../mutations';
import { usePersonQuery } from '~/pages/person/queries';
import { isAnyClubAdmin } from '~/utils/policy';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { idParamSchema } from '~/schemas';
import { endOfYear } from '~/utils/date';

const Form = withAuthentication(({ user }) => {
  const mutation = useCreateLicenseMutation();
  const { id } = useParams(idParamSchema.parse);

  async function onSubmit(data: Partial<Schema>) {
    return await mutation.mutateAsync({
      start_date: data.start_date,
      end_date: data.end_date,
      club: data.club![1],
      person: id,
    });
  }

  const startDate = new Date().toISOString().split('T')[0];
  const endDate = endOfYear().toISOString().split('T')[0];

  const defaultClub: [string, number] | undefined = user.permissions.clubs_admin.length
    ? [user.permissions.clubs_admin[0].name, user.permissions.clubs_admin[0].id]
    : undefined;

  if (isAnyClubAdmin(user.permissions)) {
    return (
      <LicenseYearForm
        defaultValues={{ club: defaultClub, start_date: startDate, end_date: endDate }}
        isLoading={mutation.isPending}
        onSubmit={onSubmit}
        mode="create"
      />
    );
  }

  return (
    <LicenseForm
      defaultValues={{ club: defaultClub, start_date: startDate, end_date: endDate }}
      isLoading={mutation.isPending}
      onSubmit={onSubmit}
      mode="create"
    />
  );
});

export const Page = withPrivateRoute(() => {
  const { id } = useParams(idParamSchema.parse);
  const { data: person } = usePersonQuery(id);

  if (!person) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Skapa licens" subText={`${person.first_name} ${person.last_name}`} />
      </PageLayout.Header>

      <PageLayout.Section>
        <Form />
      </PageLayout.Section>
    </Fragment>
  );
});
